import { EPCSActions } from "../action";

export type EPCS_STATE = {
  completed: boolean;
  error: boolean;
  loading: boolean;
  request: any;
  response: any;
  retry: number;
  success: boolean;
  hasSubmittedValidCard: boolean;
  tokenRefGuid: string | null;
};

const initialState: EPCS_STATE = {
  request: {},
  response: {},
  loading: false,
  error: false,
  success: false,
  completed: false,
  retry: 0,
  // B-2753527 - Added state to track an edge case where the user is in an error state from EPCS, has added a new card, and then edits the valid card. Added state to not send a double charge
  hasSubmittedValidCard: false,
  tokenRefGuid: null,
};

export const EPCSReducer = (state: EPCS_STATE = initialState, action: EPCSActions) => {
  switch (action.type) {
    case "REQUESTED_EPCS_STATUS":
      return { ...state, request: action.payload, loading: true };
    case "REQUESTED_EPCS_STATUS_SUCCESS":
      return { ...state, response: action.payload, loading: false, success: true, retry: 0, hasSubmittedValidCard: true,
        tokenRefGuid: state.tokenRefGuid || action.payload?.tokenRefGuid || null,
      };
    case "REQUESTED_EPCS_STATUS_FAILED":
      return { ...state, loading: false, error: true };
    case "UPDATED_EPCS_STATUS":
      return { ...state, completed: true };
    case "UPDATE_EPCSSTATUS_INCOMPLETE":
      return {
        ...state,
        completed: false,
        success: false
      };
    case "UPDATE_EPCSSTATUS_RETRY":
      return { ...state, response: action.payload, loading: false, retry: state.retry + 1 };
    case "REFRESH_EPCS_REDUCERS":
      return { ...initialState, retry: state.retry };
    case "REFRESH_REDUCERS":
      return { ...initialState };
    default:
      return state;
  }
}
